import { PrivateInterceptor } from "../../../../Base/interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../../../Base/interceptors/PublicInterceptor";

export const getEvaluacionProcedimiento = async (IdEvaluacion) => {
   return await PublicInterceptor(`Procedimientos/Evaluaciones/Evaluacion/${IdEvaluacion}`, 'GET');
}

export const getListaEvaluacionPersonal = async (IdEvaluacion) => {
   return await PrivateInterceptor(`Procedimientos/Evaluaciones/Evaluacion/ListaEvaluacionPersonal/${IdEvaluacion}`, 'GET');
}

export const guardarEvaluacion = async (respuestas) => {
   return await PublicInterceptor(`Procedimientos/Evaluaciones/PreguntasEvaluacion/GuardarPreguntas`, 'POST', {respuestas});
}


export const guardarEvaluacionNumPersonal = async (IdPersonal, IdEvaluacion) => {
   return await PublicInterceptor(`Procedimientos/Evaluaciones/PreguntasEvaluacion/persona/${IdPersonal}/${IdEvaluacion}`, 'POST');
}


export const getNumRespuestasPersonal = async (IdPersonal, IdEvaluacion) => {
   return await PublicInterceptor(`Procedimientos/Evaluaciones/NuRespuestasPersonal/${IdPersonal}/${IdEvaluacion}`, 'GET');
}